import React from 'react';

import { Box } from '@mui/material';

import { PageLayout, TabItem, Tabs } from 'src/components/common';
import { PeosTableCVStaff } from 'src/components/peo';
import { PeoPayrollProvidersTableCVStaff } from 'src/components/peoPayrollProvider';
import { pageLayoutPaperSx } from 'src/constants/styles';
import { InvitePeoByCVStaffModal } from 'src/modals/peo';
import { InvitePeoPayrollProviderByCVStaffModal } from 'src/modals/peoPayrollProvider';
import { TableDataProvider } from 'src/providers/TableDataProvider';

export const PeosPageCVStaff: React.FC = () => {
  return (
    <PageLayout titleContent="PEOs" paperSx={pageLayoutPaperSx}>
      <Box sx={{ mt: 2 }}>
        <Tabs tabs={PEOS_PAGE_TABS} additionalTabsContainerStyles={{ mx: 2 }} />
      </Box>

      <InvitePeoByCVStaffModal />
      <InvitePeoPayrollProviderByCVStaffModal />
    </PageLayout>
  );
};

const PEO_PAGE_TABS_KEY = {
  peos: 'peos',
  peoPayrollProviders: 'peoPayrollProviders',
} as const;

const PEOS_PAGE_TABS: TabItem<(typeof PEO_PAGE_TABS_KEY)[keyof typeof PEO_PAGE_TABS_KEY]>[] = [
  {
    key: PEO_PAGE_TABS_KEY.peos,
    label: 'PEOs',
    component: (
      <TableDataProvider key={PEO_PAGE_TABS_KEY.peos}>
        <PeosTableCVStaff />
      </TableDataProvider>
    ),
  },
  {
    key: PEO_PAGE_TABS_KEY.peoPayrollProviders,
    label: 'PEO Payroll Providers',
    component: (
      <TableDataProvider key={PEO_PAGE_TABS_KEY.peoPayrollProviders}>
        <PeoPayrollProvidersTableCVStaff />
      </TableDataProvider>
    ),
  },
];
